import Api, { handleError } from '@/services/Api';


// const API_URL = 'http://localhost:8000/api';
const API_URL = process.env.API_BASE;


export async function login(email, password, mfaCode) {
  const url = `${API_URL}/auth/obtain_token/`;
  const payload = {
    email,
    password
  };
  
  // Add mfa_code to payload if provided
  if (mfaCode || mfaCode === '') {
    payload.mfa_code = mfaCode;
  }
  
  const {status, data} = await Api.post(url, payload)
    .catch(handleError);

  return {status, data};

}

export async function logout(token = '') {
  const url = `${API_URL}/auth/logout/`;
  const {status, data} = await Api.post(url, null, {
    headers: {
      Authorization: `JWT ${token}`,
    },
  })
    .catch(handleError);

  return {status, data};

}

export async function trialRegister(payload) {
  const url = `${API_URL}/register_user_trial/`;

  const {status, data} = await Api.post(url, payload)
    .catch(handleError);

  return {status, data};
}

export async function trialRegisterGenerate(payload) {
  const url = `${API_URL}/register_user_trial_generate/`;

  const {status, data} = await Api.post(url, payload)
    .catch(handleError);

  return {status, data};
}

export async function trialRegisterValuation(payload) {
  const url = `${API_URL}/register_user_trial_valuation/`;

  const {status, data} = await Api.post(url, payload)
    .catch(handleError);

  return {status, data};
}

export async function getRegisterInfo(token='15c7241ebea6ca281563f147870d49c58fbf49de93d1f80447be59c6869a1397') {
  const url = `${API_URL}/register/${token}`;
  const {status, data} = await Api.get(url, { crossdomain: true })
    .catch(handleError);

  return {status, data};

}

export async function saveLoginHistory() {
  const url = `${API_URL}/login_history/`;
  const {status, data} = await Api.post(url)
    .catch(handleError);

  return {status, data};
}

export async function userToken(payload) {
  const url = `${API_URL}/user_token/`;
  const {status, data} = await Api.post(url, payload)
    .catch(handleError);

  return {status, data};

}

export async function create(payload) {
  const url = `${API_URL}/user_list/`;

  const {status, data} = await Api.post(url, payload)
    .catch(handleError);

  return {status, data};

}

export async function validate(payload) {
  const url = `${API_URL}/user_validate/`;

  const {status, data} = await Api.post(url, payload)
    .catch(handleError);

  return {status, data};

}

export async function validateUserTrial(payload) {
  const url = `${API_URL}/user_trial_validate/`;
  const {status, data} = await Api.post(url, payload).catch(handleError);

  return {status, data};
}

export async function sendResetPasswordMail(email) {
  const url = `${API_URL}/reset_password`;
  const payload = {
    email,
  };
  const {status, data} = await Api.post(url, payload)
    .catch(handleError);

  return {status, data};
}

export async function getUsers(payload) {
  const url = `${API_URL}/user_list/`;
  const {status, data} = await Api.get(url, { crossdomain: true, params: payload })
    .catch(handleError);

  return {status, data};

}

export async function verifyResetPasswordToken(token) {
  const url = `${API_URL}/reset_password?token=${token}`;
  const {status, data} = await Api.get(url)
    .catch(handleError);

  return {status, data};

}

export async function resetPassword(token, payload) {
  const url = `${API_URL}/reset_password?token=${token}`;
  const {status, data} = await Api.put(url, payload)
    .catch(handleError);

  return {status, data};

}

export async function updateOverallStdFixed(payload) {
  const url = `${API_URL}/user/overall_std_fixed/`;
  const { status, data } = await Api.post(url, payload).catch(handleError);
  return { status, data };
}

export async function getDetail(id = null) {
  let url;
  if (id !== null) {
    url = `${API_URL}/user_detail/${id}`;
  } else {
    url = `${API_URL}/user_detail/`;
  }
  const {status, data} = await Api.get(url)
    .catch(handleError);

  return {status, data};

}

export async function update(id, payload) {
  const url = `${API_URL}/user_detail/${id}`;
  const {status, data} = await Api.put(url, payload)
    .catch(handleError);

  return {status, data};

}

export async function getGeneratePromptReference(userId) {
  const url = `${API_URL}/generate_prompt_reference/${userId}/`;
  const { status, data } = await Api.get(url).catch(handleError);
  return { status, data };
}

export async function updateGeneratePromptReference(userId, payload) {
  const url = `${API_URL}/generate_prompt_reference/${userId}/`;
  const { status, data } = await Api.put(url, payload).catch(handleError);
  return { status, data };
}

export async function fetchGeneratePromptReferencePromptDefault(userId, payload) {
  const url = `${API_URL}/generate_prompt_reference/${userId}/prompt_default/`;
  const { status, data } = await Api.post(url, payload).catch(handleError);
  return { status, data };
}

export async function getUserVerificationInfo(groupId) {
  const url = `${API_URL}/user_verification_info/${groupId}`;
  const {status, data} = await Api.get(url)
    .catch(handleError);

  return {status, data};
}

export async function updatePasswordUserTrial(id, payload) {
  const url = `${API_URL}/update_password_user_trial/${id}`;
  const {status, data} = await Api.put(url, payload)
    .catch(handleError);

  return {status, data};
}

export async function changeManager(id) {
  const url = `${API_URL}/change_manager/`;
  const payload = {
    new_group_id: id,
  };
  const {status, data} = await Api.put(url, payload)
    .catch(handleError);

  return {status, data};

}

export async function loginHistory(payload) {
  const url = `${API_URL}/login_history/`;
  const {status, data} = await Api.get(url, { params: payload })
    .catch(handleError);

  return {status, data};

}

export async function loginHistoryMonthly() {
  const url = `${API_URL}/login_history_monthly/`;
  const {status, data} = await Api.get(url)
    .catch(handleError);

  return {status, data};

}

export async function loginHistoryYearly() {
  const url = `${API_URL}/login_history_yearly/`;
  const {status, data} = await Api.get(url)
    .catch(handleError);

  return {status, data};

}

export async function changePlan(id, planId, planGenerateId, userData, cardRegistration = null) {
  const url = `${API_URL}/change_plan/${id}`;
  const payload = {
    plan_id: planId,
    plan_generate_id: planGenerateId,
    user_data: userData,
  };
  if (cardRegistration && cardRegistration.paymentMethodId && cardRegistration.setupIntentId) {
    payload.payment_method_id = cardRegistration.paymentMethodId;
    payload.setup_intent_id = cardRegistration.setupIntentId;
  }

  const {status, data} = await Api.put(url, payload)
    .catch(handleError);

  return {status, data};

}

export async function getStaffs(id = '') {
  const url = `${API_URL}/user_staff/${id}`;

  const {status, data} = await Api.get(url)
    .catch(handleError);

  return {status, data};

}

export async function deleteUser(id = '') {
  const url = `${API_URL}/user_delete/${id}`;

  const {status, data} = await Api.delete(url)
    .catch(handleError);

  return {status, data};

}

export async function lockUser(listUser) {
  const url = `${API_URL}/lock_user/`;
  const payload = {
    listUser: listUser.join(','),
  };
  const {status, data} = await Api.post(url, payload)
    .catch(handleError);
  return {status, data};
}

export async function cancelContract() {
  const url = `${API_URL}/cancel_contract/`;
  const { status, data } = await Api.get(url)
    .catch(handleError);

  return { status, data };
}

export async function getCountryByIp() {
  const url = `${API_URL}/get_country_by_ip/`;
  const { status, data } = await Api.get(url)
    .catch(handleError);

  return { status, data };
}

export async function getTemporaryRegisterEmailApi() {
  const url = `${API_URL}/export_temporary_register_email/`;
  const { status, data } = await Api.get(url).catch(handleError);

  return { status, data };
}

export async function resendMfaCode(email) {
  const url = `${API_URL}/auth/resend_mfa_code/`;
  const payload = {
    email,
  };
  const { status, data } = await Api.post(url, payload)
    .catch(handleError);

  return { status, data };
}
